import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateProductQuantity, removeProduct, recalculateAllProducts } from '../../Redux/Slice/selectedProductsSlice';
import { API } from '../../Services/axios';
import { URLS } from '../../Services/urls';
import CalculationInfo from '../CalculationInfo';

const QuoteSummary = () => {
  const dispatch = useDispatch();
  const { selectedProducts, totalPrice, userInputs, projectType, sectionNames } = useSelector(state => state.selectedProducts);
  const { selectedProject } = useSelector(state => state.selectedProject);
  
  // Debug pour voir les données disponibles
  console.log('selectedProject from selectedProjectSlice:', selectedProject);
  console.log('selectedProducts from selectedProductsSlice:', selectedProducts);
  
  // Fonction pour récupérer le nom d'une section
  const getSectionName = (sectionId) => {
    console.log('Recherche du nom de section pour ID:', sectionId);
    console.log('sectionNames sauvegardés:', sectionNames);
    
    // Essayer d'abord avec les noms sauvegardés
    if (sectionNames && sectionNames[sectionId]) {
      console.log('Nom trouvé dans sectionNames:', sectionNames[sectionId]);
      return sectionNames[sectionId];
    }
    
    // Essayer avec le projet sélectionné
    if (selectedProject && selectedProject.steps) {
      for (const step of selectedProject.steps) {
        if (step.sections) {
          for (const section of step.sections) {
            if (section.id === sectionId) {
              console.log('Section correspondante trouvée dans selectedProject:', section.name);
              return section.name || `Section ${sectionId}`;
            }
          }
        }
      }
    }
    
    // Fallback: essayer de deviner le nom basé sur l'ID ou utiliser un nom générique
    const sectionNameMap = {
      '58aa0e88-2e28-49ce-9e4e-4fc6a11c2547': 'Taille de votre terrasse',
      'surface': 'Surface',
      'dimension': 'Dimensions',
      'input': 'Information'
    };
    
    console.log('Aucune section trouvée avec cet ID, utilisation du fallback');
    return sectionNameMap[sectionId] || `Section ${sectionId.substring(0, 8)}...`;
  };

  // Fonction pour formater la valeur d'un input
  const formatInputValue = (inputData) => {
    if (!inputData) return 'Non renseigné';
    
    // Si c'est une chaîne simple, la retourner
    if (typeof inputData === 'string') {
      return inputData || 'Non renseigné';
    }
    
    // Si c'est un objet avec label et value
    if (typeof inputData === 'object' && inputData !== null) {
      // Vérifier si c'est le nouveau format avec label, value, unity
      if (inputData.hasOwnProperty('value')) {
        const value = inputData.value;
        const unity = inputData.unity;
        
        if (!value || value === '') return 'Non renseigné';
        
        return unity ? `${value} ${unity}` : String(value);
      }
      
      // Si c'est un autre type d'objet, essayer de le convertir
      try {
        return String(inputData);
      } catch (e) {
        return 'Non renseigné';
      }
    }
    
    // Si c'est un autre type, essayer de le convertir
    try {
      return String(inputData);
    } catch (e) {
      return 'Non renseigné';
    }
  };

  // Fonction pour récupérer le label d'un input
  const getInputLabel = (inputData, key) => {
    if (!inputData) return key || 'Input';
    
    // Si c'est un objet avec label
    if (typeof inputData === 'object' && inputData !== null) {
      if (inputData.label) {
        return inputData.label;
      }
      // Si pas de label mais qu'il y a une value, essayer de deviner le label
      if (inputData.value !== undefined) {
        return key || 'Input';
      }
    }
    
    // Si c'est une chaîne, essayer de deviner le label basé sur la clé
    if (typeof inputData === 'string') {
      // Mapping des clés communes vers des labels plus lisibles
      const keyToLabel = {
        'surface': 'Surface',
        'longueur': 'Longueur',
        'largeur': 'Largeur',
        'hauteur': 'Hauteur',
        'epaisseur': 'Épaisseur',
        'quantite': 'Quantité',
        'prix': 'Prix',
        'dimension': 'Dimension'
      };
      
      return keyToLabel[key.toLowerCase()] || key || 'Input';
    }
    
    // Fallback
    return key || 'Input';
  };
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone_number: '',
    need_installer: false,
    be_reminded: false,
    site_address: '',
    postal_code: '',
    city: '',
    delivery_instructions: '',
    comments: '',
    user_input: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

      const handleQuantityChange = (contentProductId, section, newQuantity) => {
        if (newQuantity <= 0) {
          dispatch(removeProduct({ contentProductId, section }));
        } else {
          dispatch(updateProductQuantity({ contentProductId, section, quantity: newQuantity }));
        }
      };

  const handleRecalculate = () => {
    dispatch(recalculateAllProducts());
  };

  // Fonction pour soumettre le devis au backend (appelée lors de la finalisation)
  const submitQuoteToBackend = async () => {
    if (submitStatus === 'loading') return;
    
    setSubmitStatus('loading');
    setError(null);
    
    try {
      console.log('=== DÉBUT SOUMISSION DEVIS ===');
      console.log('FormData actuel:', formData);
      console.log('SelectedProducts:', selectedProducts);
      console.log('UserInputs:', userInputs);
      console.log('=== FIN DÉBUT SOUMISSION ===');

      // Validation des champs requis (sera faite plus tard avec la validation détaillée)

      // Préparer les items pour l'API selon le modèle
      const items = selectedProducts.map(product => {
        console.log('Produit sélectionné:', product);
        console.log('ContentProductId:', product.contentProductId);
        console.log('Section:', product.section);
        
        // Validation des IDs
        if (!product.contentProductId) {
          console.error('ContentProductId manquant pour le produit:', product);
          throw new Error(`ContentProductId manquant pour le produit: ${product.name}`);
        }
        
        if (!product.section) {
          console.error('Section manquante pour le produit:', product);
          throw new Error(`Section manquante pour le produit: ${product.name}`);
        }

        // Validation du format UUID
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if (!uuidRegex.test(product.contentProductId)) {
          console.error('ContentProductId invalide (pas un UUID):', product.contentProductId);
          throw new Error(`ContentProductId invalide pour le produit: ${product.name}`);
        }
        
        if (!uuidRegex.test(product.section)) {
          console.error('Section invalide (pas un UUID):', product.section);
          throw new Error(`Section invalide pour le produit: ${product.name}`);
        }
        
        return {
          section: product.section,
          content_product: product.contentProductId,
          quantity: Number(product.quantity) || 1,
          price: Number(product.price) || 0,
          product_type: product.productType || 'UNKNOWN'
        };
      });

      // Préparer les inputs utilisateur comme une chaîne simple
      const userInputString = Object.entries(userInputs)
        .map(([section, inputs]) => {
          const sectionName = getSectionName(section);
          const inputsString = Object.entries(inputs)
            .map(([key, inputData]) => {
              const label = getInputLabel(inputData, key);
              const value = formatInputValue(inputData);
              return `${label}: ${value}`;
            })
            .join(', ');
          return `${sectionName}: ${inputsString}`;
        })
        .join(' | ');

      // Extraire la valeur numérique pour user_input (pour l'API)
      let numericUserInput = 0; // Valeur par défaut
      Object.entries(userInputs).forEach(([sectionId, inputData]) => {
        Object.entries(inputData).forEach(([key, value]) => {
          // Chercher une valeur numérique dans les inputs
          if (typeof value === 'object' && value.value) {
            const numValue = parseFloat(value.value);
            if (!isNaN(numValue) && numValue > 0) {
              numericUserInput = numValue;
            }
          } else if (typeof value === 'string') {
            const numValue = parseFloat(value);
            if (!isNaN(numValue) && numValue > 0) {
              numericUserInput = numValue;
            }
          }
        });
      });

      console.log('🔢 Valeur numérique extraite pour user_input:', numericUserInput);
      
      // Validation stricte de user_input
      if (numericUserInput === 0 || isNaN(numericUserInput)) {
        console.warn('⚠️ Aucune valeur numérique valide trouvée, utilisation de 1 par défaut');
        numericUserInput = 1;
      }

      // Validation finale des données
      const validatedFields = {
        name: formData.name?.trim(),
        email: formData.email?.trim(),
        phone_number: formData.phone_number?.trim(),
        site_address: formData.site_address?.trim(),
        postal_code: formData.postal_code?.trim(),
        city: formData.city?.trim()
      };

      // Debug: Afficher tous les champs du formulaire
      console.log('=== INFORMATIONS DE CONTACT ===');
      console.log('FormData complet:', formData);
      console.log('Champs requis validés:', validatedFields);
      console.log('Champs optionnels:', {
        delivery_instructions: formData.delivery_instructions,
        comments: formData.comments,
        need_installer: formData.need_installer,
        be_reminded: formData.be_reminded
      });
      console.log('=== FIN INFORMATIONS DE CONTACT ===');

      // Vérifier que tous les champs requis sont remplis
      for (const [field, value] of Object.entries(validatedFields)) {
        if (!value || value.length === 0) {
          console.error(`❌ Champ manquant: ${field} = "${value}"`);
          throw new Error(`Le champ ${field} est requis`);
        } else {
          console.log(`✅ Champ valide: ${field} = "${value}"`);
        }
      }

      // Préparer les données selon le modèle Quote (version alternative)
      const quoteData = {
        name: validatedFields.name,
        email: validatedFields.email,
        phone_number: validatedFields.phone_number,
        need_installer: formData.need_installer || false,
        be_reminded: formData.be_reminded || false,
        site_address: validatedFields.site_address,
        postal_code: validatedFields.postal_code,
        city: validatedFields.city,
        delivery_instructions: formData.delivery_instructions?.trim() || null,
        comments: formData.comments?.trim() || null,
        user_input: numericUserInput,
        items: items
      };

      console.log('=== DONNÉES DE SOUMISSION ===');
      console.log('FormData:', formData);
      console.log('SelectedProducts:', selectedProducts);
      console.log('Items détaillés:', items);
      console.log('User input string:', userInputString);
      console.log('Valeur numérique extraite:', numericUserInput);
      console.log('🔍 Détail des items envoyés:');
      items.forEach((item, index) => {
        console.log(`Item ${index + 1}:`, {
          section: item.section,
          content_product: item.content_product,
          quantity: item.quantity,
          price: item.price,
          product_type: item.product_type
        });
        
        // Validation de chaque item
        if (!item.section || !item.content_product) {
          console.error(`❌ Item ${index + 1} invalide:`, item);
          throw new Error(`Item ${index + 1} invalide: section ou content_product manquant`);
        }
        if (isNaN(item.quantity) || isNaN(item.price)) {
          console.error(`❌ Item ${index + 1} invalide:`, item);
          throw new Error(`Item ${index + 1} invalide: quantity ou price invalide`);
        }
      });
      console.log('QuoteData complet:', quoteData);
      console.log('=== FIN DONNÉES ===');

      const response = await API.post(URLS.QUOTE.create(), quoteData);
      
      setSubmitStatus('success');
      console.log('Devis soumis avec succès:', response.data);
      
    } catch (error) {
      console.error('=== ERREUR DE SOUMISSION ===');
      console.error('Erreur complète:', error);
      console.error('Message d\'erreur:', error.message);
      console.error('Code de statut:', error.response?.status);
      console.error('Données de réponse:', error.response?.data);
      console.error('Headers de réponse:', error.response?.headers);
      console.error('=== FIN ERREUR ===');
      
      setSubmitStatus('error');
      setError(error.response?.data?.error || error.message || 'Erreur lors de la soumission du devis');
    }
  };

      const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        // Validation des champs requis
        const requiredFields = ['name', 'email', 'phone_number', 'site_address', 'postal_code', 'city'];
        const missingFields = requiredFields.filter(field => !formData[field] || formData[field].trim() === '');
        
        if (missingFields.length > 0) {
          setSubmitStatus('error');
          console.error('Champs manquants:', missingFields);
          alert(`Veuillez remplir tous les champs obligatoires : ${missingFields.join(', ')}`);
          setIsSubmitting(false);
          return;
        }

        try {
          // Validation des produits sélectionnés
          if (selectedProducts.length === 0) {
            alert('Veuillez sélectionner au moins un produit');
            setIsSubmitting(false);
            return;
          }

          // Debug: Afficher les produits sélectionnés
          console.log('=== VALIDATION PRODUITS ===');
          console.log('Nombre de produits sélectionnés:', selectedProducts.length);
          selectedProducts.forEach((product, index) => {
            console.log(`Produit ${index + 1}:`, {
              name: product.name,
              contentProductId: product.contentProductId,
              section: product.section,
              productType: product.productType
            });
          });
          console.log('=== FIN VALIDATION ===');

          // Préparer les items pour l'API selon le modèle
          const items = selectedProducts.map(product => {
            console.log('Produit sélectionné:', product);
            console.log('ContentProductId:', product.contentProductId);
            console.log('Section:', product.section);
            
            // Validation des IDs
            if (!product.contentProductId) {
              console.error('ContentProductId manquant pour le produit:', product);
              throw new Error(`ContentProductId manquant pour le produit: ${product.name}`);
            }
            
            if (!product.section) {
              console.error('Section manquante pour le produit:', product);
              throw new Error(`Section manquante pour le produit: ${product.name}`);
            }

            // Validation du format UUID
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            if (!uuidRegex.test(product.contentProductId)) {
              console.error('ContentProductId invalide (pas un UUID):', product.contentProductId);
              throw new Error(`ContentProductId invalide pour le produit: ${product.name}`);
            }
            
            if (!uuidRegex.test(product.section)) {
              console.error('Section invalide (pas un UUID):', product.section);
              throw new Error(`Section invalide pour le produit: ${product.name}`);
            }
            
            return {
              section: product.section,
              content_product: product.contentProductId,
              quantity: Number(product.quantity) || 1,
              price: Number(product.price) || 0,
              product_type: product.productType || 'UNKNOWN'
            };
          });

          // Préparer les inputs utilisateur comme une chaîne simple
          const userInputString = Object.entries(userInputs)
            .map(([section, inputs]) => {
              const sectionName = getSectionName(section);
              const inputsString = Object.entries(inputs)
                .map(([key, inputData]) => {
                  const label = getInputLabel(inputData, key);
                  const value = formatInputValue(inputData);
                  return `${label}: ${value}`;
                })
                .join(', ');
              return `${sectionName}: ${inputsString}`;
            })
            .join(' | ');

          // Extraire la valeur numérique pour user_input (pour l'API)
          let numericUserInput = 0; // Valeur par défaut
          Object.entries(userInputs).forEach(([sectionId, inputData]) => {
            Object.entries(inputData).forEach(([key, value]) => {
              // Chercher une valeur numérique dans les inputs
              if (typeof value === 'object' && value.value) {
                const numValue = parseFloat(value.value);
                if (!isNaN(numValue) && numValue > 0) {
                  numericUserInput = numValue;
                }
              } else if (typeof value === 'string') {
                const numValue = parseFloat(value);
                if (!isNaN(numValue) && numValue > 0) {
                  numericUserInput = numValue;
                }
              }
            });
          });

          console.log('🔢 Valeur numérique extraite pour user_input:', numericUserInput);
          
          // Validation stricte de user_input
          if (numericUserInput === 0 || isNaN(numericUserInput)) {
            console.warn('⚠️ Aucune valeur numérique valide trouvée, utilisation de 1 par défaut');
            numericUserInput = 1;
          }

          // Validation finale des données
          const requiredFields = {
            name: formData.name?.trim(),
            email: formData.email?.trim(),
            phone_number: formData.phone_number?.trim(),
            site_address: formData.site_address?.trim(),
            postal_code: formData.postal_code?.trim(),
            city: formData.city?.trim()
          };

          // Validation finale des données
          const validatedFields = {
            name: formData.name?.trim(),
            email: formData.email?.trim(),
            phone_number: formData.phone_number?.trim(),
            site_address: formData.site_address?.trim(),
            postal_code: formData.postal_code?.trim(),
            city: formData.city?.trim()
          };

          // Debug: Afficher tous les champs du formulaire
          console.log('=== INFORMATIONS DE CONTACT ===');
          console.log('FormData complet:', formData);
          console.log('Champs requis validés:', validatedFields);
          console.log('Champs optionnels:', {
            delivery_instructions: formData.delivery_instructions,
            comments: formData.comments,
            need_installer: formData.need_installer,
            be_reminded: formData.be_reminded
          });
          console.log('=== FIN INFORMATIONS DE CONTACT ===');

          // Vérifier que tous les champs requis sont remplis
          for (const [field, value] of Object.entries(validatedFields)) {
            if (!value || value.length === 0) {
              console.error(`❌ Champ manquant: ${field} = "${value}"`);
              throw new Error(`Le champ ${field} est requis`);
            } else {
              console.log(`✅ Champ valide: ${field} = "${value}"`);
            }
          }

          // Préparer les données selon le modèle Quote (version alternative)
          const quoteData = {
            name: requiredFields.name,
            email: requiredFields.email,
            phone_number: requiredFields.phone_number,
            need_installer: formData.need_installer || false,
            be_reminded: formData.be_reminded || false,
            site_address: requiredFields.site_address,
            postal_code: requiredFields.postal_code,
            city: requiredFields.city,
            delivery_instructions: formData.delivery_instructions?.trim() || null,
            comments: formData.comments?.trim() || null,
            user_input: numericUserInput,
            items: items
          };

          console.log('=== DONNÉES DE SOUMISSION ===');
          console.log('FormData:', formData);
          console.log('SelectedProducts:', selectedProducts);
          console.log('Items détaillés:', items);
          console.log('User input string:', userInputString);
          console.log('Valeur numérique extraite:', numericUserInput);
          console.log('🔍 Détail des items envoyés:');
          items.forEach((item, index) => {
            console.log(`Item ${index + 1}:`, {
              section: item.section,
              content_product: item.content_product,
              quantity: item.quantity,
              price: item.price,
              product_type: item.product_type
            });
            
            // Validation de chaque item
            if (!item.section || !item.content_product) {
              console.error(`❌ Item ${index + 1} invalide:`, item);
              throw new Error(`Item ${index + 1} invalide: section ou content_product manquant`);
            }
            if (isNaN(item.quantity) || isNaN(item.price)) {
              console.error(`❌ Item ${index + 1} invalide:`, item);
              throw new Error(`Item ${index + 1} invalide: quantity ou price invalide`);
            }
          });
          console.log('QuoteData complet:', quoteData);
          console.log('=== FIN DONNÉES ===');

          const response = await API.post(URLS.QUOTE.create(), quoteData);
          
          setSubmitStatus('success');
          console.log('Devis soumis avec succès:', response.data);
          
          // Optionnel: vider la sélection après soumission
          // dispatch(clearSelectedProducts());
          
        } catch (error) {
          setSubmitStatus('error');
          console.error('=== ERREUR DE SOUMISSION ===');
          console.error('Erreur complète:', error);
          console.error('Message d\'erreur:', error.message);
          console.error('Code de statut:', error.response?.status);
          console.error('Données de réponse:', error.response?.data);
          console.error('Headers de réponse:', error.response?.headers);
          console.error('=== FIN ERREUR ===');
          
          // Afficher un message d'erreur plus informatif
          if (error.response?.data?.error) {
            alert(`Erreur serveur: ${error.response.data.error}`);
          } else if (error.message) {
            alert(`Erreur: ${error.message}`);
          } else {
            alert('Erreur lors de la soumission du devis. Veuillez réessayer.');
          }
        } finally {
          setIsSubmitting(false);
        }
      };

  if (selectedProducts.length === 0) {
    return (
      <div className="container py-5">
        <div className="alert alert-info text-center">
          <h4>Aucun produit sélectionné</h4>
          <p>Veuillez sélectionner des produits dans les étapes précédentes pour voir le récapitulatif.</p>
        </div>
      </div>
    );
  }

  return (
    // <div className="container py-5">
    //   <div className="row">
    //     <div className="col-lg-8">
    //       <div className="d-flex justify-content-between align-items-center mb-4">
    //         <h2>Récapitulatif de votre devis</h2>
    //             <div>
    //               <span className="badge bg-info me-2">Type: {projectType}</span>
    //               <button 
    //                 className="btn btn-outline-primary btn-sm me-2"
    //                 onClick={handleRecalculate}
    //               >
    //                 <i className="fas fa-calculator me-1"></i>
    //                 Recalculer
    //               </button>
    //               <button 
    //                 className="btn btn-outline-secondary btn-sm me-2"
    //                 onClick={() => {
    //                   console.log('=== TEST PRODUITS SÉLECTIONNÉS ===');
    //                   console.log('selectedProducts:', selectedProducts);
    //                   console.log('userInputs:', userInputs);
    //                   console.log('=== FIN TEST ===');
    //                 }}
    //               >
    //                 <i className="fas fa-bug me-1"></i>
    //                 Debug
    //               </button>
    //               <button 
    //                 className="btn btn-outline-warning btn-sm me-2"
    //                 onClick={async () => {
    //                   console.log('=== TEST API MINIMAL ===');
    //                   try {
    //                     const testData = {
    //                       name: "Test Client",
    //                       email: "test@example.com",
    //                       phone_number: "0123456789",
    //                       need_installer: false,
    //                       be_reminded: false,
    //                       site_address: "123 Test Street",
    //                       postal_code: "75001",
    //                       city: "Paris",
    //                       delivery_instructions: null,
    //                       comments: null,
    //                       user_input: null,
    //                       items: []
    //                     };
    //                     console.log('Données de test:', testData);
    //                     const response = await API.post(URLS.QUOTE.create(), testData);
    //                     console.log('✅ Test réussi:', response.data);
    //                   } catch (error) {
    //                     console.error('❌ Test échoué:', error.response?.data);
    //                   }
    //                   console.log('=== FIN TEST API ===');
    //                 }}
    //               >
    //                 <i className="fas fa-flask me-1"></i>
    //                 Test API
    //               </button>
    //               <button 
    //                 className="btn btn-outline-info btn-sm"
    //                 onClick={() => {
    //                   console.log('=== TEST FORMULAIRE CONTACT ===');
    //                   console.log('État actuel du formulaire:');
    //                   console.log('Nom:', formData.name);
    //                   console.log('Email:', formData.email);
    //                   console.log('Téléphone:', formData.phone_number);
    //                   console.log('Adresse:', formData.site_address);
    //                   console.log('Code postal:', formData.postal_code);
    //                   console.log('Ville:', formData.city);
    //                   console.log('Instructions livraison:', formData.delivery_instructions);
    //                   console.log('Commentaires:', formData.comments);
    //                   console.log('Besoin installateur:', formData.need_installer);
    //                   console.log('Être rappelé:', formData.be_reminded);
    //                   console.log('=== FIN TEST FORMULAIRE ===');
    //                 }}
    //               >
    //                 <i className="fas fa-user me-1"></i>
    //                 Test Contact
    //               </button>
    //             </div>
    //       </div>
          
    //       {/* Informations sur les calculs */}
    //       <CalculationInfo projectType={projectType} />
          
    //        {/* Récapitulatif des inputs utilisateur */}
    //        {(() => {
    //          console.log('userInputs:', userInputs);
    //          console.log('selectedProject:', selectedProject);
    //          return null;
    //        })()}
    //        {Object.keys(userInputs).length > 0 ? (
    //          <div className="card mb-4">
    //            <div className="card-header">
    //              <h5>
    //                <i className="fas fa-info-circle me-2"></i>
    //                Informations renseignées
    //              </h5>
    //            </div>
    //            <div className="card-body">
    //              {Object.entries(userInputs).map(([section, inputs]) => {
    //                // Vérifier que inputs est un objet valide
    //                if (!inputs || typeof inputs !== 'object') return null;
                   
    //                return (
    //                  <div key={section} className="mb-4">
    //                    <h6 className="text-primary border-bottom pb-2 mb-3">
    //                      <i className="fas fa-layer-group me-2"></i>
    //                      {getSectionName(section)}
    //                    </h6>
    //                    <div className="row">
    //                      {Object.entries(inputs).map(([key, inputData]) => {
    //                        // Vérifier que inputData existe et est valide
    //                        if (!inputData) return null;
                           
    //                        // Debug pour voir la structure des données
    //                        console.log('Input data for key', key, ':', inputData);
                           
    //                        const label = getInputLabel(inputData, key);
    //                        const displayValue = formatInputValue(inputData);
                           
    //                        console.log('Label:', label, 'DisplayValue:', displayValue);
                           
    //                        // Vérification de sécurité supplémentaire
    //                        if (typeof displayValue === 'object') {
    //                          console.error('Tentative de rendre un objet:', displayValue);
    //                          return null;
    //                        }
                           
    //                        return (
    //                          <div key={key} className="col-md-6 mb-3">
    //                            <div className="d-flex justify-content-between align-items-center p-3 bg-light rounded">
    //                              <span className="fw-bold text-dark">{String(label)}:</span>
    //                              <span className="text-end text-primary fw-bold">
    //                                {String(displayValue)}
    //                              </span>
    //                            </div>
    //                          </div>
    //                        );
    //                      })}
    //                    </div>
    //                  </div>
    //                );
    //              })}
    //            </div>
    //          </div>
    //        ) : (
    //          <div className="card mb-4">
    //            <div className="card-body text-center py-5">
    //              <i className="fas fa-info-circle fa-3x text-muted mb-3"></i>
    //              <h5 className="text-muted">Aucune information renseignée</h5>
    //              <p className="text-muted">Les informations que vous renseignez dans les étapes précédentes apparaîtront ici.</p>
    //            </div>
    //          </div>
    //        )}

    //       <div className="card mb-4">
    //         <div className="card-header">
    //           <h5>Produits sélectionnés</h5>
    //         </div>
    //         <div className="card-body">
    //           {selectedProducts.map((product, index) => (
    //             <div key={`${product.id}-${product.section}`} className="d-flex justify-content-between align-items-center border-bottom py-3">
    //               <div className="d-flex align-items-center">
    //                 <img 
    //                   src={product.image} 
    //                   alt={product.name}
    //                   style={{ width: '60px', height: '60px', objectFit: 'cover' }}
    //                   className="me-3"
    //                 />
    //                 <div>
    //                   <h6 className="mb-1">{product.name}</h6>
    //                   <small className="text-muted">{product.sku}</small>
    //                   <div className="mt-1">
    //                     <span className="badge bg-secondary me-1">{product.productType}</span>
    //                     {product.isCalculated && (
    //                       <span className="badge bg-success">
    //                         <i className="fas fa-calculator me-1"></i>
    //                         Calculé auto
    //                       </span>
    //                     )}
    //                     {product.calculatedQuantity && product.calculatedQuantity !== product.quantity && (
    //                       <small className="text-muted ms-2">
    //                         (Calculé: {product.calculatedQuantity})
    //                       </small>
    //                     )}
    //                   </div>
    //                 </div>
    //               </div>
                  
    //               <div className="d-flex align-items-center">
    //                 <div className="me-3">
    //                   <label className="form-label small">Quantité:</label>
    //                   <input
    //                     type="number"
    //                     min="1"
    //                     value={product.quantity}
    //                         onChange={(e) => handleQuantityChange(product.contentProductId, product.section, parseInt(e.target.value))}
    //                     className="form-control form-control-sm"
    //                     style={{ width: '80px' }}
    //                   />
    //                 </div>
                    
    //                 <div className="text-end me-3">
    //                   <div className="fw-bold">{product.price.toFixed(2)} € / m²</div>
    //                   <div className="text-muted small">Total: {(product.totalPrice).toFixed(2)} €</div>
    //                 </div>
                    
    //                     <button
    //                       className="btn btn-outline-danger btn-sm"
    //                       onClick={() => dispatch(removeProduct({ contentProductId: product.contentProductId, section: product.section }))}
    //                     >
    //                   <i className="fas fa-trash"></i>
    //                 </button>
    //               </div>
    //             </div>
    //           ))}
    //         </div>
    //       </div>

    //       <div className="card">
    //         <div className="card-header">
    //           <h5>Total du devis</h5>
    //         </div>
    //         <div className="card-body">
    //           <div className="d-flex justify-content-between align-items-center">
    //             <h4>Total TTC</h4>
    //             <h4 className="text-primary">{totalPrice.toFixed(2)} €</h4>
    //           </div>
    //         </div>
    //       </div>
    //     </div>

    //     <div className="col-lg-4">
    //       <div className="card">
    //         <div className="card-header">
    //           <h5>Informations de contact</h5>
    //         </div>
    //         <div className="card-body">
    //           <form onSubmit={handleSubmit}>
    //             <div className="mb-3">
    //               <label className="form-label">Nom *</label>
    //               <input
    //                 type="text"
    //                 name="name"
    //                 value={formData.name}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 required
    //               />
    //             </div>

    //             <div className="mb-3">
    //               <label className="form-label">Email *</label>
    //               <input
    //                 type="email"
    //                 name="email"
    //                 value={formData.email}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 required
    //               />
    //             </div>

    //             <div className="mb-3">
    //               <label className="form-label">Téléphone *</label>
    //               <input
    //                 type="tel"
    //                 name="phone_number"
    //                 value={formData.phone_number}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 required
    //               />
    //             </div>

    //             <div className="mb-3">
    //               <label className="form-label">Adresse du chantier *</label>
    //               <input
    //                 type="text"
    //                 name="site_address"
    //                 value={formData.site_address}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 required
    //               />
    //             </div>

    //             <div className="row mb-3">
    //               <div className="col-md-6">
    //                 <label className="form-label">Code postal *</label>
    //                 <input
    //                   type="text"
    //                   name="postal_code"
    //                   value={formData.postal_code}
    //                   onChange={handleInputChange}
    //                   className="form-control"
    //                   required
    //                 />
    //               </div>
    //               <div className="col-md-6">
    //                 <label className="form-label">Ville *</label>
    //                 <input
    //                   type="text"
    //                   name="city"
    //                   value={formData.city}
    //                   onChange={handleInputChange}
    //                   className="form-control"
    //                   required
    //                 />
    //               </div>
    //             </div>

    //             <div className="mb-3">
    //               <label className="form-label">Instructions de livraison</label>
    //               <textarea
    //                 name="delivery_instructions"
    //                 value={formData.delivery_instructions}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 rows="3"
    //               />
    //             </div>

    //             <div className="mb-3">
    //               <label className="form-label">Commentaires</label>
    //               <textarea
    //                 name="comments"
    //                 value={formData.comments}
    //                 onChange={handleInputChange}
    //                 className="form-control"
    //                 rows="3"
    //               />
    //             </div>

    //             <div className="mb-3">
    //               <div className="form-check">
    //                 <input
    //                   type="checkbox"
    //                   name="need_installer"
    //                   checked={formData.need_installer}
    //                   onChange={handleInputChange}
    //                   className="form-check-input"
    //                 />
    //                 <label className="form-check-label">
    //                   J'ai besoin d'un installateur
    //                 </label>
    //               </div>
    //             </div>

    //             <div className="mb-3">
    //               <div className="form-check">
    //                 <input
    //                   type="checkbox"
    //                   name="be_reminded"
    //                   checked={formData.be_reminded}
    //                   onChange={handleInputChange}
    //                   className="form-check-input"
    //                 />
    //                 <label className="form-check-label">
    //                   Me rappeler par email
    //                 </label>
    //               </div>
    //             </div>

    //             {submitStatus === 'success' && (
    //               <div className="alert alert-success">
    //                 Votre devis a été soumis avec succès !
    //               </div>
    //             )}

    //               {submitStatus === 'error' && (
    //                 <div className="alert alert-danger">
    //                   <i className="fas fa-exclamation-triangle me-2"></i>
    //                   Erreur lors de la soumission du devis. 
    //                   <br />
    //                   <small>Vérifiez que tous les champs obligatoires sont remplis et réessayez.</small>
    //                 </div>
    //               )}

    //             <button
    //               type="button"
    //               className="btn btn-primary w-100"
    //               disabled={isSubmitting}
    //               onClick={submitQuoteToBackend}
    //             >
    //               {isSubmitting ? 'Soumission...' : 'Je commande mon devis'}
    //             </button>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div>  
    </div>
  );
};

export default QuoteSummary;
